import { StoreAttributes } from '@pylot-data/hooks/product/graphql/Fragments/StoreAttributes'
export const productsFragment = /* GraphQL */ `
aggregations {
    __typename
    attribute_code
    count
    label
    options {
        __typename
        label
        value
        count
    }
}
__typename
sort_fields {
    __typename
    default
    options {
        __typename
        label
        value
    }
}
items {
    __typename
    id
    name
    brand
    brand_text
    product_eyebrow_badge
    product_eyebrow_badge_text
    stock_status
    short_description {
        html
    }
    custom_kit_short_description
    is_custom_kit
    mp_label_data {
        priority
        label_template
        label_image
        same
        list_template
        list_image
    }
    price_range {
        __typename
        minimum_price {
            __typename
            regular_price {
                __typename
                value
                currency
            }
            final_price {
                __typename
                value
                currency
            }
            discount {
                __typename
                amount_off
            }
        }
        maximum_price {
            final_price {
              value
              currency
            }
        }
    }
    sku
    small_image {
        __typename
        url
    }
    url_key
    attribute_set_name
    categories {
        name
        url_path
        breadcrumbs {
            category_id
            category_name
        }
    }
    ... on BundleProduct {
        is_custom_kit
        items{
            ooka_product_option
            options {
                uid
            }
        }
    }

    ... on ConfigurableProduct {
        configurable_options {
            __typename
            attribute_code
            attribute_id
            id
            label
            values {
                __typename
                value_index
                label
                swatch_data {
                    __typename
                    value
                    ... on ImageSwatchData {
                        thumbnail
                        __typename
                    }
                }
            }
        }
        variants {
            __typename
            attributes {
                __typename
                code
                value_index
                label
                uid
            }
            product {
                __typename
                id
                small_image {
                    __typename
                    url
                }
                sku
                stock_status
            }
        }
        __typename
    }
    addtocart_popup_cms
    ${StoreAttributes}
    subtitle
}
page_info {
    __typename
    total_pages
    current_page
}
total_count
`
